import React from "react";
import ReactPaginate from "react-paginate";

export const Pagination = ({ pageInfo, setOffset, offset }) => {
  const handlePageClick = (data) => {
    setOffset(data.selected);
  };
  if (pageInfo?.totalCounts > pageInfo?.limit)
    return (
      <div className="mt-5">
        <ReactPaginate
          previousLabel={"<<"}
          nextLabel={">>"}
          breakLabel={"..."}
          disableInitialCallback={true}
          forcePage={offset}
          pageCount={Math.ceil(pageInfo?.totalCounts / pageInfo?.limit)}
          marginPagesDisplayed={3}
          pageRangeDisplayed={3}
          onPageChange={handlePageClick}
          containerClassName={"pagination justify-content-center"}
          pageClassName={"page-item"}
          pageLinkClassName={"page-link"}
          previousClassName={"page-item"}
          previousLinkClassName={"page-link"}
          nextClassName={"page-item"}
          nextLinkClassName={"page-link"}
          breakClassName={"page-item"}
          breakLinkClassName={"page-link"}
          activeClassName={"active"}
        />
      </div>
    );
};
